<script lang="ts">
    import {onMount} from 'svelte';
    import type {AxiosInstance} from 'axios';

    import {ANALYTICS, COOKIE_VALUE, TEMPLATE} from 'general/constants';
    import {duration, dyData, modal} from 'general/store';

    import FlipItem from 'desktop/components/flipItem/FlipItem.svelte';
    import Theme from 'general/theme/Theme.svelte';
    import CloseButton from 'general/components/closeButton/CloseButton.svelte';
    import Description from 'general/components/description/Description.svelte';
    import ActionButton from 'general/components/actionButton/ActionButton.svelte';
    import Policy from 'general/components/policy/Policy.svelte';
    import QrCode from 'desktop/components/qrcode/QrCode.svelte';
    import DyButton from 'general/components/dyButton/DyButton.svelte';
    import {pushPopupEvent} from 'general/libs/pushDataLayer';
    import {setCookie} from 'general/libs/setCookie';
    import {QR_CODE_SMS_SUBSCRIBED} from 'desktop/templates/circleModal/constants';

    import s from './style.module.css';

    onMount(() => {
        if ($dyData.qrCode?.sms && !sessionStorage.getItem(QR_CODE_SMS_SUBSCRIBED)) {
            sessionStorage.setItem(QR_CODE_SMS_SUBSCRIBED, 'true');
            pushPopupEvent(ANALYTICS.POPUP_SUBSCRIBED_SMS);
        }
    });

    const onMainButtonClick = () => {
        duration.update('flip', {in: 600});
        modal.changeState('typ');
        pushPopupEvent(ANALYTICS.CTA_BUTTON_CLICKED);
    };

    const onQrButtonClick = () => {
        setCookie(COOKIE_VALUE.SUBSCRIBER_PHONE, 'true', 365);
        modal.close();
    };

    export let instance: AxiosInstance;
</script>

<FlipItem>
    <Theme template={TEMPLATE.CIRCLE} color={$dyData.side.sms?.backgroundColor}>
        <div class={s.qrWrapper} style="margin-top: {$dyData.side.sms?.marginTop || 0}">
            <CloseButton handleClick={modal.close} theme="dark" />
            <Description value={$dyData.description?.sms} />
            <Policy side="sms" />
            {#if $dyData.qrCode?.sms}
                <QrCode
                    {instance}
                    text={$dyData.qrCode.sms.text}
                    size={$dyData.qrCode.sms.size}
                    marginBottom={$dyData.qrCode.sms.marginBottom}
                    marginTop={$dyData.qrCode.sms.marginTop}
                />
                <ActionButton
                    handleClick={onQrButtonClick}
                    color="dodgerBlue"
                    marginTop="8px"
                    fontSize="22px"
                    fontWeight="700"
                    children="Got it"
                    {...$dyData.actionButton?.sms || {}}
                />
            {:else if $dyData.mainButton?.sms}
                <DyButton
                    onClick={onMainButtonClick}
                    size="medium"
                    children="Click to see the QR code"
                    {...$dyData.mainButton?.sms}
                />
            {:else}
                <div class={s.buttonContainer}>
                    <button type="button" on:click={onMainButtonClick} class={s.qrButton}>
                        Click to see the QR code
                    </button>
                </div>
            {/if}
        </div>
    </Theme>
</FlipItem>
